import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl2;
const service = 'batterycontrol';
const mastersUrl = `${baseUrl}/${service}/bat/seq/masters`;
const detailsUrl = `${baseUrl}/${service}/bat/seq/details`;

// All endpoints plural, POST/DELETE body = { data: [dto, ...] }
class BatSeqService extends ServiceBase {
    _config = () => ({
        headers: {
            Authorization: `Bearer ${this.getToken()}`,
            'Content-Type': 'application/json',
        },
    });

    /** @returns {Promise} all sequence masters */
    getMasters = () => agent.get(mastersUrl, this._config());

    /** @param {object[]} items - BatSeqMaster DTOs, add or update */
    postMasters = (items) => agent.post(mastersUrl, { data: items }, this._config());

    /** @param {object[]} items - full BatSeqMaster DTOs */
    deleteMasters = (items) => agent.delete(mastersUrl, { ...this._config(), data: { data: items } });

    /** @returns {Promise} all sequence details (steps) */
    getDetails = () => agent.get(detailsUrl, this._config());

    /** @param {object[]} items - BatSeqDetail DTOs, add or update */
    postDetails = (items) => agent.post(detailsUrl, { data: items }, this._config());

    /** @param {object[]} items - full BatSeqDetail DTOs */
    deleteDetails = (items) => agent.delete(detailsUrl, { ...this._config(), data: { data: items } });
}

const batSeqService = new BatSeqService();
export default batSeqService;
